import UserDataSource, {ICreateAccountData} from "data/UserDataSource";

declare var $:any;
declare var navigator:any;

import { observable, computed, action } from "mobx";
import {getUrlParameter} from 'utils';
import {User} from "data/entities/User";
import {FeedData} from "./FeedData";
import {ISolution, solutionDataSource} from "./SolutionDataSource";
import {API} from "../api";
import {Bundle, IBundle} from "./BundleData";
import {Transport} from "data/transport";

class _UIStateVendor {
  @observable windowWidth:number;
  @observable windowHeight:number;
  @observable iOS:boolean = false;
  @observable settings:any = null;

  /* @ts-ignore */
  @observable private _user:User = null;
  @computed get user() {
    return this._user;
  }

  @computed
  get isMobile() {
    return this.windowWidth<901;
  }

  @computed get isLoggedIn() {
    return this._user;
  }

  @computed get hasVendorBooths() {
    return this.isLoggedIn && this.bundles && this.bundles.length>0;
  }

  @observable bundles:Bundle[] = [];
  @observable private _selectedBooth:Bundle;
  @computed get selectedBooth():Bundle {
    return this._selectedBooth;
  }
  @action setSelectedBooth = (booth:Bundle) => {
    this._selectedBooth = booth;
  }

  @computed get selectedSolutionId() {
    if(this._selectedBooth && this._selectedBooth.solutions && this._selectedBooth.solutions.length > 0) {
      return this._selectedBooth.solutions[0];
    }
    return "";
  }

  @observable loadDashboard = () => {
    API.get('/vendor/dashboard')
        .then((response:any)=>{
          for(let i=0;i<response.length;i++) {
            this.bundles.push(new Bundle(response[i]))
          }
        })
        .catch(()=>{

        });
  }

  @observable feedData:FeedData;
  loadSolution = (solutionId:string) => new Promise<void>(((resolve, reject) => {
    solutionDataSource.solutionForId(solutionId)
    .then((solution: ISolution) => {
      FeedData.feedDataFactory(solution)
      .then((feedData:FeedData) => {
        this.feedData = feedData;
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
    })
    .catch((err) => {
      reject(err);
    })
  }));

  /**
   * Retrieve portal settings and then check whether there
   * is an authorized user.
   */
  @action
  loadSettings = () => new Promise<void>((resolve, reject) => {

    Transport.GET('/settings')
      .then((data:any)=> {
        const openForLogin = getUrlParameter('OPEN_FOR_LOGIN');
        if (openForLogin && openForLogin == 'true') {
          data.PLATFORM_OPEN = true;
        }
        this.settings = data;
        UserDataSource.checkAuthVendor()
          .then((response: any) => {
            this._user = new User(response.user);
            this.loadDashboard();
            resolve();
          })
          .catch(() => {
            UIStateVendor.clearState();
            reject();
          });

      })
      .catch((reason)=> {
        console.log(reason)
      });

    // $.ajax({ dataType:'json', type:'GET', url: URL('/settings') })
    // .done((data)=>{
    //
    //   const openForLogin = getUrlParameter('OPEN_FOR_LOGIN');
    //   if(openForLogin && openForLogin=='true') {
    //     data.PLATFORM_OPEN = true;
    //   }
    //
    //
    //   this.settings = data;
    //
    //   UserDataSource.checkAuthVendor()
    //   .then((response:any)=>{
    //     this._user = new User(response.user);
    //     this.loadDashboard();
    //     resolve();
    //   })
    //   .catch(()=>{
    //     UIStateVendor.clearState();
    //     reject();
    //   });
    // })
    // .fail(()=>{
    //   reject();
    // });
  });

  @action clearState = () => {
    document.cookie = 'strive=; path=/; domain=.well-concepts.com; expires=' + new Date(0).toUTCString();
    localStorage.removeItem('token');
    // @ts-ignore
    this._user = null;
    this.bundles = [];
  }

  @action createVendorAccount = (data:ICreateAccountData, avatarBlobData?:any) => new Promise<void>((resolve, reject) => {
    UserDataSource.createVendorAccount(data)
    .then((response)=>{
      localStorage.setItem('token', response.token);
      this._user = new User(response.user);
      if(avatarBlobData) {
        UserDataSource.saveUserProfile( this._user, { avatarBlobData:avatarBlobData, avatarURL:null })
            .then(()=>{resolve();  })
            .catch(()=>{resolve();  });
      } else {
        resolve();
      }
    })
    .catch((reason)=>{
      reject(reason);
    })
  })

  @action attemptLogin = (email:string, password:string) => new Promise<void>((resolve, reject) => {
    UserDataSource.attemptLoginVendor(email, password)
    .then((response:any)=>{
      localStorage.setItem('token', response.token);
      this._user = new User(response.user);
      this.loadDashboard();
      resolve();
    })
    .catch((err)=>{
      reject(err);
    });
  })

  @computed
  get POJSisTouchDeviceConstant() {
    return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  }

  @action
  handleWindowResize = () => {
    this.windowWidth = document.documentElement.clientWidth;
    this.windowHeight = document.documentElement.clientHeight;
  }

  alert =  (message:string) => {
    alert(message);
  }

  constructor() {
    this.iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  }

}

const UIStateVendor = new _UIStateVendor();
export { UIStateVendor };
